import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import BackdropModal from 'components/portal/backdrop-modal'
import { withI18next } from 'lib/i18n/withI18next'
import compose from 'recompose/compose'
import { connect } from 'react-redux'
import ResponsiveImage from 'components/images/responsive-image'
import { BUTTON_HTML_TYPE } from 'constants/button'
import Icon, { ICONS, ICON_SIZE } from 'components/common/icon'
import { segmentReviewViewImageClicked } from 'components/pdp/reviews/pdp-reviews-segment/pdpReviewsSegment'
import styles from './review-images-modal.scss'

const ReviewImagesModal = ({
  id_product,
  id_product_review_image,
  segmentEvent,
  isPhone,
  imageUrl,
  triggerImageClassName,
  children,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const openModal = useCallback(() => setIsModalOpen(true), [setIsModalOpen])
  const closeModal = useCallback(() => setIsModalOpen(false), [setIsModalOpen])
  const handleOpenModal = () => {
    openModal()
    segmentReviewViewImageClicked({
      id_product,
      id_product_review_image,
      event: segmentEvent,
    })
  }

  return (
    <React.Fragment>
      <style jsx>{styles}</style>
      <ResponsiveImage
        cy={triggerImageClassName}
        className={triggerImageClassName}
        src={imageUrl}
        alt="product-image"
        imgRatio={1.33}
        isLocalImage
        onClick={handleOpenModal}
      />
      <BackdropModal
        onBackdropClick={closeModal}
        freezeBody={isPhone}
        isOpen={isModalOpen}
      >
        <div
          data-cy="review-images-modal-container__dialog"
          className="review-images-modal-container__dialog"
        >
          <button
            data-cy="review-images-modal-container__close-ctn"
            className="review-images-modal-container__close-ctn"
            type={BUTTON_HTML_TYPE.button}
            onClick={closeModal}
          >
            <Icon
              alt="close dialog"
              src={ICONS.close}
              size={ICON_SIZE.medium}
            />
          </button>
          {children}
        </div>
      </BackdropModal>
    </React.Fragment>
  )
}

ReviewImagesModal.defaultProps = {
  // component props
  id_product: null,
  id_product_review_image: null,
  segmentEvent: '',
  imageUrl: '',
  triggerImageClassName: '',
}

ReviewImagesModal.propTypes = {
  // component props
  id_product: PropTypes.number,
  id_product_review_image: PropTypes.number,
  segmentEvent: PropTypes.string,
  imageUrl: PropTypes.string,
  triggerImageClassName: PropTypes.string,
  children: PropTypes.node.isRequired,

  // redux props
  isPhone: PropTypes.bool.isRequired,
}

export default compose(
  connect((state) => ({
    isPhone: state.device.isPhone,
  })),
  withI18next(),
)(ReviewImagesModal)
